export const sendTagsWrapper = {
    paddingBottom: '60px',
    position: 'relative',
}

export const footerIcon = {
    color: '$tagIcon',
    display: 'inline-flex',
    width: '16px',
}

export const footer = {
    '> div:first-child': {
        alignItems: 'center',
        display: 'flex',
        gap: '10px',
    },
    'backgroundColor': '$modalFooterBackground',
    'borderBottomLeftRadius': '5px',
    'borderBottomRightRadius': '5px',
    'borderTop': '1px solid $modalFooterBorder',
    'bottom': 0,
    'boxSizing': 'border-box',
    'display': 'flex',
    'justifyContent': 'space-between',
    'left': 0,
    'padding': '15px',
    'position': 'absolute',
    'right': 0,
    'width': '100%',
    // eslint-disable-next-line sort-keys
    'small': {
        alignItems: 'center',
        color: '$tagIcon',
        display: 'inline-flex',
        marginRight: '15px',
        span: {
            fontWeight: 'bold',
            marginRight: '5px',
        },
    },
}

export const tags = {
    '> div:first-child': {
        display: 'flex',
        flexDirection: 'column',
        gap: '14px',
    },
    'maxHeight': '40vh',
    'overflowY': 'auto',
    'padding': '15px',
    'position': 'relative',
    'variants': {oneColumn: {true: {'> div:first-child': {display: 'block'}}}},
}

export const tag = {
    button: {
        '&:focus-visible': {outline: '2px solid $buttonOutlineFocus'},
        'background': 'transparent',
        'border': 0,
        'padding': 0,
    },
    marginBottom: '5px',
    marginRight: '5px',
}

export const childTags = {
    display: 'flex',
    flexWrap: 'wrap',
    marginLeft: '20px',
}
